import React from "react";
import { MdCheckCircle } from "react-icons/md";

function ChannelRow(props) {
  const Row = (
    <tr>
      <td>{props.number}</td>
      <td>{props.name}</td>
      <td className="has-text-centered">
        {props.packages.includes("Local Plus") ? (
          <MdCheckCircle size={"1.5em"} />
        ) : (
          ""
        )}
      </td>
      <td className="has-text-centered">
        {props.packages.includes("Complete Lite") ? (
          <MdCheckCircle size={"1.5em"} />
        ) : (
          ""
        )}
      </td>
      <td className="has-text-centered">
        {props.packages.includes("Complete") ? (
          <MdCheckCircle size={"1.5em"} />
        ) : (
          ""
        )}
      </td>
      <td className="has-text-centered">
        {props.packages.includes("Advanced") ? (
          <MdCheckCircle size={"1.5em"} />
        ) : (
          ""
        )}
      </td>
      <td className="has-text-centered">
        {props.packages.includes("Ultra") ? (
          <MdCheckCircle size={"1.5em"} />
        ) : (
          ""
        )}
      </td>
      <td>
        {!props.packages.includes("Complete") &&
        !props.packages.includes("Local Plus")
          ? props.packages
              .filter(
                (packageName) =>
                  packageName !== "Advanced" && packageName !== "Ultra"
              )
              .map((packageName) => <p key={packageName}>{packageName}</p>)
          : ""}
      </td>
    </tr>
  );

  return <>{Row}</>;
}

export default ChannelRow;
